/** @format */

import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchResource } from "./resourceAPI";
import { RootState } from "../../app/store";
import { Resource } from "./types";

export interface ResourcesState {
  resource?: Resource;
  resourceId?: string;
  status: "idle" | "loading" | "failed";
}

const initialState: ResourcesState = {
  resource: undefined,
  resourceId: undefined,
  status: "idle",
};

export const addResource = createAsyncThunk(
  "resources/addResource",
  async (resourceId: string) => {
    const { data } = await fetchResource(resourceId);
    return data;
  },
);

export const resourcesSlice = createSlice({
  name: "resources",
  initialState,
  reducers: {
    setResourceId: (state, action: PayloadAction<string | undefined>) => {
      state.resourceId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addResource.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addResource.fulfilled, (state, action) => {
        state.resource = action.payload;
        state.status = "idle";
      })
      .addCase(addResource.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export const { setResourceId } = resourcesSlice.actions;

export const selectStatus = () => (state: RootState) => state.resources.status;
export const selectResourceSelector = (state: RootState, resourceId?: string) =>
  (resourceId && state.resources.resource) || undefined;
export const selectResource = (resourceId?: string) => (state: RootState) =>
  selectResourceSelector(state, resourceId);

export default resourcesSlice.reducer;
